import {
  ARCHIVED_FILTER_NAME,
  FILTER_NAME_SUB_MENU,
  STATUS_FILTER_NAME,
  UNREAD_FILTER_NAME,
} from '../../../../../constants/filter'

export const REQUEST_BOARD_CHANGE_STATUS_TOTAL_COUNT = 1

export const REQUEST_BOARD_STATUS_KEPT_FILTER_NAMES = [
  ARCHIVED_FILTER_NAME,
  FILTER_NAME_SUB_MENU,
  STATUS_FILTER_NAME,
  UNREAD_FILTER_NAME,
]
